import { SelectionWizardListName } from '../actions/phrasesSelectorWizard';

import { CampaignType } from './domain';

export interface PhrasesSelectorWizardGroupInfo {
    id: string;
    name: string;
    campaign: {
        type?: CampaignType;
        name: string;
        id: string;
        strategy: {
            isAutoBudget: boolean;
        };
    };
    minusKeywords: string[];
    regionIds: number[];
    startPhrases?: PhrasesSelectorListItem[];
}

export enum KeywordsStatDictionaryKeys {
    searchedAlso = 'searchedAlso',
    searchedWith = 'searchedWith'
}

export interface KeywordsStatDictionary {
    [key: string]: {
        [KeywordsStatDictionaryKeys.searchedAlso]: PhrasesSelectorListItem[];
        [KeywordsStatDictionaryKeys.searchedWith]: PhrasesSelectorListItem[];
    };
}

export enum PhrasesSelectorWizardId {
    editGroupsPage = 'editGroupsPage',
    sideBar = 'sideBar',
    groupsGrid = 'groupsGrid'
}

export interface PhrasesSelectorWizardState {
    groupInfo: PhrasesSelectorWizardGroupInfo;
    isVisible: boolean;
    isInProgress: boolean;
    startPhrases: PhrasesSelectorListItem[];
    chosenPhrases: PhrasesSelectorListItem[];

    minusWordsList: PhrasesSelectorListItem[];
    columnsVisibility: {
        [SelectionWizardListName.similarPhrases]: boolean;
        [SelectionWizardListName.chosenPhrases]: boolean;
    };
    keywordsStat: KeywordsStatDictionary;
    phrasesSelection: {
        [key: string]: boolean;
    };

    priceContext?: number;
}

export interface PhrasesSelectorColumnsVisibilityData {
    [SelectionWizardListName.similarPhrases]?: boolean;
    [SelectionWizardListName.chosenPhrases]?: boolean;
}

export interface ChangePhrasesSelectorWizardState {
    startPhrases?: PhrasesSelectorListItem[];
    keywordsStat?: {
        [key: string]: {
            searchedAlso: PhrasesSelectorListItem[];
            searchedWith: PhrasesSelectorListItem[];
        };
    };
    isInProgress: boolean;
    isVisible?: boolean;
}

export interface PhrasesSelectorListItem {
    text: string;
    selected: boolean;
    shows: number;
}
